<template>
  <button class="nd-button"
          :class="[isDisabled, fixedStyle, theme, loading? 'loading':'' ]"
          @click.prevent="clickHandler"
          :style="{width: `${width}rem`, height: `${height}rem`}"
  >
    <slot></slot><img v-if="loading && showLoadingIcon" class="loading-icon" src="./images/loading.png" srcset="./images/loading@2x.png 2x, ./images/loading@3x.png 3x"/>
  </button>
</template>

<script>
export default {
  name: 'nd-button',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      required: false
    },
    height: {
      type: Number,
      required: false
    },
    isBackground: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'bottom' // 可选择top, bottom
    },
    theme: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    // loading状态下是否显示加载图标
    showLoadingIcon: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    isDisabled () {
      return this.disabled ? 'disabled' : ''
    },
    fixedStyle () {
      return this.fixed ? `fixed-${this.align}` : ''
    }
  },

  methods: {
    clickHandler (event) {
      if (!this.disabled) {
        this.$emit('click', event)
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/mixin.less";

@keyframes loading {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
    .nd-button {
        width: 650px;
        height: 94px;
        line-height: 94px;
        font-size: 32px;
        border-radius: 45px;
        padding: 0;
        border: none;
        outline: none;
        font-family: PingFangSC-Regular,PingFang SC;
        font-weight: 400;
        transition: .3s;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
        color: #FFFFFF;
        -webkit-appearance: none;
        &.loading {
            background:linear-gradient(90deg,rgba(255,51,51,1) 0%,rgba(255,95,52,1) 100%) !important;
            opacity: .4;
            .loading-icon {
                        vertical-align: middle;

                width: 36px;
                height: 36px;
                margin-left: 6px;
                animation: loading ease-in-out 1s infinite;
            }
        }

        &.small {
            height: 88px;
            line-height: 88px;
            width: 360px;
        }

        &.line {
            box-sizing: border-box;
            border-width: 2px;
            border-style: solid;
            border-color: @theme;
            color: @theme;
            background: #FFFFFF;

            &.disabled {
                background: white;
                color: #DDDDDD;
                border-color: #DDDDDD;
            }
        }

        &.fixed-bottom {
            height: 94px;
            line-height: 94px;
            width: 100%;
            position: fixed;
            bottom: 0;
            z-index: 1;
            border-radius: 0;
        }

        &.fixed-top {
            height: 94px;
            line-height: 94px;
            width: 100%;
            position: fixed;
            top: 0;
            z-index: 1;
            border-radius: 0;
        }

        &.disabled {
            background: #DDDDDD !important;
        }
    }
</style>
